import React, { useRef, useEffect } from 'react';

function useOutsideAlerter(ref: any, outsideClickHandler: () => void) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        outsideClickHandler();
        //alert('You clicked outside of me!');
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, outsideClickHandler]);
}

const OutsideAlerter = ({
  children,
  outsideClickHandler,
  isActive = true,
}: {
  children: React.ReactNode;
  outsideClickHandler: () => void;
  isActive?: boolean;
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef, outsideClickHandler);

  return (
    <>
      <div
        className='vh-100 vw-100'
        style={{
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: -1,
        }}
      ></div>
      <div
        className='h-full w-full'
        style={{ width: isActive ? '100%' : '0' }}
        ref={wrapperRef}
      >
        {children}
      </div>
    </>
  );
};

export default OutsideAlerter;
